import * as Yup from "yup";
import { FormGroup } from "../../../components/form";

export const providerForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "formGroup",
      heading: "KIS Provider",
      classNameOpt: "kisProviderDetails mt-3 my-0",
      fields: [
        {
          type: "field",
          key: "providerName",
          fieldType: "input",
          label: "KIS Provider Name",
          props: {
            disabled: true,
          },
        },
        {
          type: "field",
          key: "region",
          fieldType: "input",
          label: "Region",
          props: {
            disabled: true,
          },
        },
        {
          type: "field",
          key: "area",
          fieldType: "input",
          label: "Area",
          props: {
            disabled: true,
          },
        },
        {
          type: "field",
          key: "contactNumber",
          fieldType: "input",
          label: "Telephone Number",
          validation: Yup.string()
            .notRequired()
            .matches(
              RegExp(
                "^((04\\d{2} ?\\d{3} ?\\d{3})|(\\+614 ?\\d{4} ?\\d{4})|((\\(02\\)|\\(03\\)|\\(08\\)) ?\\d{4} ?\\d{4})|(02|03|08)\\s?\\d{4} ?\\d{4}|(\\+613 ?\\d{4} ?\\d{4})|(\\d{4}|d{4})|(\\d{4}\\s?\\d{4}))$"
              ),
              {
                message: "Please enter a valid Telephone number",
              }
            ),
        },
      ],
    },
    {
      type: "formGroup",
      heading: "Provider Contact Email",
      classNameOpt: "kisProviderDetails",
      fields: [
        {
          type: "field",
          key: "providerEmail1",
          fieldType: "input",
          label: "KIS Provider email 1",
          validation: Yup.string()
            .trim()
            .required("A response is required")
            .matches(RegExp("^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$"), { message: "Please enter a valid email address" }),
        },
        {
          type: "field",
          key: "providerEmail2",
          fieldType: "input",
          label: "KIS Provider email 2",
          validation: Yup.string().notRequired().matches(RegExp("^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$"), {
            message: "Please enter a valid email address",
          }),
        },
      ],
    },
    {
      type: "formGroup",
      heading: "Provider Contact ECIB Email",
      classNameOpt: "kisProviderDetails",
      fields: [
        {
          type: "field",
          key: "ecibEmail1",
          fieldType: "input",
          label: "ECIB email 1",
          validation: Yup.string()
            .notRequired()
            .matches(RegExp("^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$"), { message: "Please enter a valid email address" }),
        },
        {
          type: "field",
          key: "ecibEmail2",
          fieldType: "input",
          label: "ECIB email 2",
          validation: Yup.string().notRequired().matches(RegExp("^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,}$"), {
            message: "Please enter a valid email address",
          }),
        },
      ],
    },
  ],
};
